export default __webpack_public_path__ + "static/media/shortcut_transfer.2ec5340b.svg";